var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],class:_vm.modifierClass,domProps:{"innerHTML":_vm._s(_vm.blok.text.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }